import React, {
  FunctionComponent,
  SyntheticEvent
} from 'react';
import classnames from 'classnames';

import { BasePillProps } from '@components/library/pill';
import { keyPressHelper } from '@helpers/accessibility';

const baseName = 'pill';

export const BasePill: FunctionComponent<BasePillProps> = ({
  children,
  className,
  isTabbable = true,
  onClick,
  onClose,
  selected,
  styleClasses,
  value,
  variantName,
  ...pillProps
}) => (
  <div
    {...pillProps}
    className={classnames(
      `bf-${baseName}__${variantName}`, // base-variant class for post consumption styling
      styleClasses[variantName], // class for css modules
      className, // user specified class
      {
        [styleClasses.clickable]: !!onClick,
        [styleClasses.closeable]: !!onClose,
        [styleClasses.selected]: selected,
      }
    )}
  >
    <button
      className={classnames(
        [styleClasses['pill-button']],
        {
          [styleClasses.clickable]: !!onClick,
        }
      )}
      onClick={onClick ? (e: SyntheticEvent): void => onClick(value, e) : undefined}
      onKeyUp={onClick ? keyPressHelper((e: SyntheticEvent) => onClick(value, e)) : undefined}
      tabIndex={!isTabbable ? -1 : undefined}
      type="button"
    >
      {children}
    </button>
    {!!onClose && (
      <button
        aria-label={`close pill ${children?.toString() || ''}`}
        className={classnames(
          [styleClasses['close-button']],
        )}
        data-testid="close-pill-button"
        onClick={onClose ? (e: SyntheticEvent): void => onClose(value, e) : undefined}
        onKeyUp={onClose ? keyPressHelper((e: SyntheticEvent) => onClose(value, e)) : undefined}
        tabIndex={!isTabbable ? -1 : undefined}
        type="button"
      >
        <span className="bff-close" />
      </button>
    )}
  </div>
);
